import { FC, ReactNode, CSSProperties } from "react";

interface DefaultProps {
	icon: ReactNode;
	heading: string;
	subtitle: string;
	borderColor?: string;
	backgroundColor?: string;
	borderWidth?: number;
	className?: string;
	style?: CSSProperties;
}

export type Props = Partial<DefaultProps>;

const MonthlyHighlightCard: FC<Props> = ({
	icon,
	heading,
	subtitle,
	borderWidth
}) => {
	const isHighlighted = Boolean(borderWidth);

	return (
		<div
			className={
				isHighlighted
					? "rounded-xl bg-primary-lighter border-2 border-primary-light p-5 text-center shadow-sm hover:shadow-md hover:-translate-y-px transition-all duration-200"
					: "rounded-xl bg-white border border-border-light p-5 text-center shadow-sm hover:shadow-md hover:-translate-y-px transition-all duration-200"
			}
		>
			<div className="flex flex-col items-center">
				{icon && <div className="text-zinc-500 mb-2">{icon}</div>}

				{heading && (
					<h3 className="font-heading text-xl font-semibold text-zinc-800">
						{heading}
					</h3>
				)}

				{subtitle && (
					<p className="text-[13px] text-zinc-600 mt-1">{subtitle}</p>
				)}
			</div>
		</div>
	);
};

export default MonthlyHighlightCard;
